module.exports = __webpack_public_path__ + "img/turbo_on.4b24ac18.svg";